import { appConfig } from 'config'
import currency from 'currency.js'

export function getPriceWithTip(
  price_including_sales_tax: currency.Any,
  tax_exempt: boolean
) {
  return currency(price_including_sales_tax).multiply(
    1 +
      (tax_exempt
        ? (appConfig.tip.percentages[2] ?? 0)
        : appConfig.tip.defaultPercentage)
  )
}
